<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto">
      <component :is="model.heading" class="mb-3 text-2xl">{{ model.title }}</component>
      <div v-html-safe="contentValue" class="block-content"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

export interface IProps {
  model: {
    heading: string;
    title: string;
    text: string | { html: string };
  };
  id: string;
  background?: string;
  textColor?: string;
}

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    "text-block py-4 lg:py-8",
    props.background === "bg-[color:var(--color-primary-500)]" ? "primary-bg" : "",
  ];
});

const props = defineProps<IProps>();

const contentValue = computed(() => {
  return typeof props.model.text === "object" ? props.model.text?.html : props.model.text;
});
</script>

<style lang="scss">
.text-block {
  .block-content {
    p {
      margin-bottom: 1.5rem;
    }
    ul {
      list-style: disc inside;
      margin-bottom: 1.5rem;
    }
    a {
      font-weight: bold;
    }
  }
}
</style>
